// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
  production: true,
  firebaseconfig :  {
  apiKey: "AIzaSyAc8mzdgz2T6nDzPHXpKn_fb94fDGMW9LI",
  authDomain: "paarsel-dev.firebaseapp.com",
  databaseURL: "https://paarsel-dev.firebaseio.com",
  projectId: "paarsel-dev",
  storageBucket: "gs://paarsel-dev.appspot.com/",
  messagingSenderId: "286776163578",
  appId: "1:286776163578:web:470dd52c077c7ac6"
  }
  /* firebaseconfig :  {
    apiKey: "AIzaSyDGgfRaJXAdYRqwDnUHqlKclWyRm-U_yxE",
    authDomain: "paarsel-59e80.firebaseapp.com",
    databaseURL: "https://paarsel-59e80.firebaseio.com",
    projectId: "paarsel-59e80",
    storageBucket: "paarsel-59e80.appspot.com",
    messagingSenderId: "1048823346724"
    } */
};




// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/environments/environment.ts